import { z } from "zod";

export const workflowChoiceOptionSchema = z.object({ value: z.string().min(1), label: z.string().min(1) });
export const choiceEditorSchema = z.object({
    project_id: z.string(),
    draft_id: z.string(),
    instance_id: z.string(),
    node_id: z.string(),
    expected_revision: z.number().int().positive(),
    options: z.array(workflowChoiceOptionSchema).min(1),
    selected_value: z.string().nullable()
});
export const choicePreviewSchema = z.object({ value: z.string().min(1), content: z.string().trim().min(1) });
export type WorkflowChoiceOption = z.infer<typeof workflowChoiceOptionSchema>;
export type ChoiceEditorConfig = z.infer<typeof choiceEditorSchema>;
export type ChoicePreview = z.infer<typeof choicePreviewSchema>;
export type WorkflowSelectedValues = Record<string, string | null>;
